export const WareHouseConstants = {
  PAGE_HEADERS: {
    WARE_HOUSE: "Warehouse",
    WARE_HOUSE_DETAILS: "Warehousing",
  },
  UTILS: {
    ADD_WAREHOUSE: "Add New",
    EMPTY_ARCHIVE_WAREHOUSE_TITLE: "Archived Ware House",
    EMPTY_WAREHOUSE_TITLE: "Ware House",
    EMPTY_WAREHOUSE_SUBTITLE: "Add new warehouse to manage your inventory",
    EMPTY_ARCHIVE_WAREHOUSE_SUBTITLE: "Archived Ware House will appear here",
    ARCHIVE_CONFIRMATION_SUBTITLE:
      "If you archive this warehouse, you can't undo this action.",
    ARCHIVE_CONFIRMATION_BTN_NAME: "Yes, Archive it",
    CLOSE_PROJECT_CONFIRMATION_SUBTITLE:
      "If you close this project, you can't undo this action",
    CLOSE_PROJECT_CONFIRMATION_BTN_NAME: "Yes, Close it",
    CLOSE_ITEM_TITLE: "Are you sure ?",
    CLOSE_ITEM_SUBTITLE:
      "You are about to close this item. This action can't be undone",
  },
  FORM: {
    CREATE_WAREHOUSE: "Add Customer To Warehouse",
    CREATE_WAREHOUSE_ITEM: "Add New Item",
    ASSIGN_PROJECT: "Assign Project",
    UPDATE_WAREHOUSE_ITEM: "Edit Item",
    UPDATE_WAREHOUSE_ITEM_QUANTITY: "Update Quantity",
    RETURN_ITEM: "Return Items",
    CLOSE_CANCEL: "No, Cancel",
    CLOSE_YES: "Yes, Closed",
  },
  TOAST_MESSAGES: {
    WAREHOUSE_CREATED: "WareHouse Created Successfully",
    WAREHOUSE_ARCHIVE: "WareHouse Archived Successfully",
    WAREHOUSE_DETAIL_ITEM_CREATED: "Item Added Successfully",
    ASSIGN_PROJECT: "Project Assigned Successfully",
    UPDATE_WAREHOUSE_ITEM: "Item Updated Successfully",
    UPDATE_WAREHOUSE_ITEM_QUANTITY: "Quantity Updated Successfully",
    DELETED_WAREHOUSE_ITEM: "Item Deleted Successfully",
    RETURN_ITEM: "Item Returned Successfully",
    PROJECT_CLOSED: "Project Closed Successfully",
  },
  KEYS: {
    WAREHOUSE_ID: "warehouseId",
    WAREHOUSE_ITEM_ID: "warehouseItemId",
    WAREHOUSE_PROJECT_ID: "warehouseProjectId",
    WAREHOUSE_DETAILS: "warehouseDetails",
    WAREHOUSE_CUSTOMER_ID: "customerId",
    WAREHOUSE_DETAIL_PROJECT_ID: "warehouseDetailProjectId",
  },
};

export enum WareHouseProjectStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
}

export type WareHouseTab = "SUMMARY" | "ACTIVE" | "ASSIGN_HISTORY";

export enum WareHouseStatus {
  ACTIVE = "ACTIVE",
  ARCHIVE = "ARCHIVE",
}
